import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup,  NgForm } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { EnvioService } from 'app/main/wizard-cgo/services/envio.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';

import { AlertDialogComponent } from 'app/main/pagina/certificar/alertdialog/alertdialog.component';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";

//SERVICE
import { DispatchService } from "app/main/pagina/certificar/services/dispatch.service";


///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_dispatch } from 'app/idiomas/i18n/dispatch/dispatch.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import Swal from 'sweetalert2';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {FormControl,  Validators} from '@angular/forms';

interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};

@Component({
    selector     : 'dispatch',
    templateUrl  : './dispatch.component.html',
    styleUrls    : ['./dispatch.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations : fuseAnimations
})
export class DispatchComponent implements OnInit {

  dialogRef: any;
  form: FormGroup;
  centered = false;
  disabled = false;
  unbounded = false;
  clave : string = '';
  url : string = '';
  radius: number;
  color: string;
  flag: boolean = false;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;

  constructor(
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    private envioService: EnvioService,
    private service : DispatchService,
    private mail_service : DispatchService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService
  ){

  lang_dispatch.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });


        //console.log(this._translateService.instant('data.SHEDULE.TITLE1'));

  this.getPilotoData();


  }
  ngOnInit() {
    this.obtieneCertificarActual();


    // this.form = this._formBuilder.group({
    //   email01: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email02: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email03: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email04: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    //   email05: ['', Validators.compose([
    //     Validators.minLength(5),
    //     Validators.required
    //   ])],
    // });
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.envioService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              this.pasoCompleto = false;
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.envioService.getStatusEnvio(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {

        if(data.estatus === 3)

          this.pasoCompleto = true;
      });

      this.getStatusModal();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      envio: 1
    };
    console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('ENVIO');
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      envio: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  completarPaso(){
    if(this.pasoCompleto){
      this.aletaRestric('ENVIO.COMPLETADO',null,'warning');
    }
    else{
      if(this.flag){
        this.aletaRestric('ENVIO.COMPLETAR',true);
      }
      else{
        this.aletaRestric('ENVIO.NADA',null,'warning');
      }
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.envioService.guardaStatusEnvio(this.productoCertificar.idCertificar).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '216'){
              this.aletaRestric('ENVIO.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '250px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

    });
  }

  private sendMail(){
        let data={
            'fechaCertificar' : localStorage.getItem('fechaProducto')
        };
        this.service.sendMail(data)
        .subscribe(response => {
            console.log(response);

        }, error => {
          //console.log(error);
        });

  }

  private getPilotoData(){
        let data={
            'productoId' : localStorage.getItem('productoID')
        };

        this.service.getPilotoData(data)
          .subscribe(response => {
              // console.log(response);
              if(response['message'] = "Success"){
                this.clave = response['piloto']['clave'];
                this.url = response['piloto']['url'];
                if(response['correosEnviados'] == true){
                  this.flag = true;
                }else{
                  this.flag = false;
                }
              }


            }, error => {
              //console.log(error);
            });

  }

  showAlert(): void {
        // this.dialogRef = this.dialog.open(AlertDialogComponent, {
        //   data: {'header': 'Info','message':'Do you want to continue with the shipment?','cancel':'No, cancel','accept':'Ok, send'}
        // });
        //
        // this.dialogRef.afterClosed()
        //     .subscribe(result => {
        //     if(result == 'true'){
        //       this.sendMail();
        //       this.flag = true;
        //     }else{
        //       console.log('false');
        //       this.flag = false;
        //     }
        //   });
        let texto = 'DISPATCH.ALERT.MESSAGE';
        let rspSi = 'DISPATCH.ALERT.BTN_CONFIRM';
        let rspNo = 'DISPATCH.ALERT.BTN_CANCEL';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
        this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
        Swal.fire({
          title: texto,
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          
          
          confirmButtonText: rspSi,
          cancelButtonText: rspNo
        }).then((result) => {
          if (result.value) {
            this.sendMail();
            this.flag = true;
          }
        });
    }

  email01:any;
  playerName="";
  getEmails(e){
    e.preventDefault();
    // if(this.form.valid){
      console.log("Diferentes email");
      let email01:string;
      let email02:string;
      let email03:string;
      let email04:string;
      let email05:string;
      if($("#email01").val().length>0){
        email01=$("#email01").val();
      }
      else{
        email01="localhost@localhost.com"
      }

      if($("#email02").val().length>0){
        email02=$("#email02").val();
      }
      else{
        email02="localhost@localhost.com"
      }

      if($("#email03").val().length>0){
        email03=$("#email03").val();
      }
      else{
        email03="localhost@localhost.com"
      }

      if($("#email04").val().length>0){
        email04=$("#email04").val();
      }
      else{
        email04="localhost@localhost.com"
      }

      if($("#email05").val().length>0){
        email05=$("#email05").val();
      }
      else{
        email05="localhost@localhost.com"
      }
      let data={
        'fechaCertificar' : localStorage.getItem('fechaProducto'),
        'correos':[
          {
            "email":email01
          },{
            "email":email02
          },{
            "email":email03
          },{
            "email":email04
          },{
            "email":email05
          },
        ]
      };
      /*this.envioService.sendEmail_CF(data).subscribe((data:backInter.infoProductos) => {
          console.log(data);
      });*/


      this.mail_service.sendEmail_CF(data)
      .subscribe(response=> {
        //console.log(response);
        if(response['message'] = "Success"){
          let texto = 'DISPATCH.LABEL06'+'';
          let newTexto:string;
          this.translateSrv.get(texto).subscribe((res: string) => { newTexto = res; });
          Swal.fire({
            title: newTexto,
            icon: "success",
            confirmButtonColor: '#e40601'
          });
        }
      });


    // }else{
    //   let texto = 'DISPATCH.LABEL05'+'';
    //   let newTexto:string;
    //   this.translateSrv.get(texto).subscribe((res: string) => { newTexto = res; });
    //   console.log(newTexto);
    //   Swal.fire({
    //     title: newTexto,
    //     icon: "error",
    //     confirmButtonColor: '#e40601'
    //   });
    //
    // }



  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

}
